<template>
  <div>
    <HeaderComponent />
    <main>
      <RouterView />
    </main>
    <FooterComponent />
  </div>
</template>

<script>
import { RouterView } from "vue-router";
//import { defineComponent } from "vue";
import HeaderComponent from "./components/HeaderComponent.vue"; 
import FooterComponent from "./components/FooterComponent.vue";
//import "aos/dist/aos.css"; // Import AOS styles
import "@/assets/theme/styles.css";


export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
    RouterView
  }
}
</script>

<style>

</style>
